import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ENG_MONTHS } from '@iotv/datamodel-core';
import { Box, TextField, ThemeProvider } from '@mui/material';
import React from 'react';
import { smallerInputThemeNoPadding } from '../../../cosmetics/Themes/MuiInputSmallerNoPadding';
import { getDayInputMenuItems, getHoursInputMenuItems, getMinutesInputMenuItems, getMonthInputMenuItems, getYearInputMenuItems } from './dateHelperFns';
const debug = process.env.REACT_APP_DEBUG && false;
export const DateInput = (props) => {
    const { matchedPrimary, viewKeyDefinition, updateKV, functionOverrides } = props;
    const stdOptions = {
        size: 'small',
        margin: 'dense',
        variant: 'standard',
        type: 'number',
        InputLabelProps: { shrink: true },
    };
    //debug && console.log('Validation res', validationError)
    const inputType = viewKeyDefinition.type;
    const currentValue = matchedPrimary[viewKeyDefinition.key];
    const isValidMs = typeof currentValue === 'number';
    const currentSetDate = isValidMs ? new Date(currentValue) : new Date('1970-01-01');
    let [year, month, day, hour, min] = [
        currentSetDate.getFullYear(),
        currentSetDate.getMonth(),
        currentSetDate.getDate(),
        currentSetDate.getHours(),
        currentSetDate.getMinutes(),
    ];
    const keyBase = `${matchedPrimary.sk ?? 'newObject'}_${viewKeyDefinition.key}`;
    return (_jsx(ThemeProvider, { theme: smallerInputThemeNoPadding, children: _jsxs(Box, { component: 'div', children: [_jsx(TextField, { select: true,
                    onChange: (event) => {
                        const derivedValue = event.target.value;
                        currentSetDate.setFullYear(parseInt(derivedValue));
                        const pseudoEvent = {
                            currentTarget: {
                                type: 'number',
                                value: currentSetDate.valueOf().toString(),
                            },
                        };
                        updateKV(pseudoEvent, viewKeyDefinition.key);
                    },
                    value: year,
                    label: 'Y',
                    disabled: viewKeyDefinition.editable === false,
                    ...stdOptions, children: getYearInputMenuItems(year, 1, 1) }, `${keyBase},_inputYear`), _jsx(TextField, { select: true,
                    onChange: (event) => {
                        const derivedValue = event.target.value;
                        currentSetDate.setMonth(Object.values(ENG_MONTHS).findIndex((v) => v === derivedValue));
                        const pseudoEvent = {
                            currentTarget: {
                                type: 'number',
                                value: currentSetDate.valueOf().toString(),
                            },
                        };
                        updateKV(pseudoEvent, viewKeyDefinition.key);
                    },
                    value: ENG_MONTHS[month],
                    label: 'M',
                    disabled: viewKeyDefinition.editable === false,
                    ...stdOptions, children: getMonthInputMenuItems() }, `${keyBase},_inputMonth`), _jsx(TextField, { select: true,
                    onChange: (event) => {
                        const derivedValue = event.target.value;
                        day = parseInt(derivedValue);
                        currentSetDate.setDate(day);
                        const pseudoEvent = {
                            currentTarget: {
                                type: 'number',
                                value: currentSetDate.valueOf().toString(),
                            },
                        };
                        updateKV(pseudoEvent, viewKeyDefinition.key);
                    },
                    value: day,
                    label: 'D',
                    disabled: viewKeyDefinition.editable === false,
                    ...stdOptions, children: getDayInputMenuItems(year, month) }, `${keyBase},_inputDay`), _jsx(TextField, { select: true,
                    onChange: (event) => {
                        const derivedValue = event.target.value;
                        hour = parseInt(derivedValue);
                        currentSetDate.setHours(hour);
                        const pseudoEvent = {
                            currentTarget: {
                                type: 'number',
                                value: currentSetDate.valueOf().toString(),
                            },
                        };
                        updateKV(pseudoEvent, viewKeyDefinition.key);
                    },
                    value: hour,
                    label: 'H',
                    disabled: viewKeyDefinition.editable === false,
                    ...stdOptions, children: getHoursInputMenuItems() }, `${keyBase},_inputHour`), _jsx(TextField, { select: true,
                    onChange: (event) => {
                        const derivedValue = event.target.value;
                        const minute = parseInt(derivedValue);
                        currentSetDate.setMinutes(minute);
                        const pseudoEvent = {
                            currentTarget: {
                                type: 'number',
                                value: currentSetDate.valueOf().toString(),
                            },
                        };
                        updateKV(pseudoEvent, viewKeyDefinition.key);
                    },
                    type: inputType,
                    value: min,
                    label: 'M',
                    disabled: viewKeyDefinition.editable === false,
                    ...stdOptions, children: getMinutesInputMenuItems() }, `${keyBase},_inputMinute`)] }) }));
};
